export const isSSNValid = (ssn: string): boolean => {
  if (!ssn) return false;

  // Ta bort bindestreck och mellanslag för validering
  const cleaned = ssn.replace(/[-\s]/g, '');

  // Kontrollera att det är 12 siffror
  if (cleaned.length !== 12) return false;
  if (!/^\d{12}$/.test(cleaned)) return false;

  // Validera datum-delen
  const year = parseInt(cleaned.substring(0, 4));
  const month = parseInt(cleaned.substring(4, 6));
  const day = parseInt(cleaned.substring(6, 8));

  if (year < 1900 || year > new Date().getFullYear()) return false;
  if (month < 1 || month > 12) return false;
  if (day < 1 || day > 31) return false;

  return true;
};

export const isEmailValid = (email: string): boolean => {
  const regex = new RegExp(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );
  return regex.test(email.toLowerCase());
};
